import 'twin.macro';
import React from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import List from './List';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Attachments from '@teetsh/app/src/components/Attachments/PillButtonAttachment';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { TrashIcon as Trash } from '@heroicons/react/20/solid';
import { PhotoIcon as Photograph } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (v?: string) => void;
  isOpen: boolean;
  onClose: () => void;
  onUpload?: ({ file }: { file: File }) => Promise<any>;
  isUploading?: boolean;
}

export function AvatarPicker(props: Props) {
  const { onChange, onClose, onUpload, isUploading, isOpen } = props;
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common']);
  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <Dialog.Body>
        <div>
          {onUpload && (
            <>
              <div tw="text-center font-bold text-2xl mb-4">
                {t('common:components.avatarPicker.choosePicture')}
              </div>
              <div tw="mb-16">
                <Attachments
                  handleError={({ message }) => notifyError({ title: message })}
                  onChange={v => {
                    onChange(`${v[0].s3Path}/${v[0].s3Filename}`);
                    onClose();
                  }}
                  handleUploadAttachment={({ file }) => onUpload({ file })}
                  icon={Photograph}
                  label={t('common:components.avatarPicker.addPicture')}
                  acceptOnly="images"
                />
              </div>
            </>
          )}
          <div tw="text-center font-bold text-2xl mb-4">
            {onUpload
              ? t('common:components.avatarPicker.orChooseAnAvatar')
              : t('common:components.avatarPicker.chooseAnAvatar')}
          </div>
          <h3 tw="mb-2">{t('common:components.avatarPicker.girls')}</h3>
          <List
            onChange={v => {
              onChange(v);
              onClose();
            }}
            type="girl"
          />
        </div>
        <h3 tw="mb-2">{t('common:components.avatarPicker.boys')}</h3>
        <List
          onChange={v => {
            onChange(v);
            onClose();
          }}
          type="boy"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          intent="danger"
          large
          onClick={() => {
            onChange('user');
            onClose();
          }}
          loading={isUploading}
          icon={Trash}
        >
          {t('common:components.avatarPicker.noPicture')}
        </Button>
        <Button loading={isUploading} large onClick={onClose}>
          {t('common:buttons.cancel')}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}
